<template>
  <div>
    <DetailForm
      :title-image="team.companyLogo"
      :title="`${record.name} - Referral Application`"
      description="Please fill out the application as accurately as possible. After submitting we will review your application and get back to you as soon as possible."
      action="Submit"
      actioncolor="black"
      :hidecancel="true"
      :hideaction="applicationSuccess"
      :action-disabled="!isFormValid"
      @handle-action="submitApplication"
    >
      <div v-if="applicationSuccess" class="mt-1 text-center text-sm text-gray-500">
        We have successfully received your application! Thanks for applying. We will get back to you with next steps as
        soon as possible.
      </div>
      <div v-else>
        <ApplyReferralForm
          :record="record"
          :model-value="application"
          @update:model-value="application = $event"
          @form-valid="updateFormValidity"
        />
      </div>
    </DetailForm>
  </div>
</template>

<script>
import DetailForm from '../shared/DetailForm.vue';
import ApplyReferralForm from './ApplyReferralForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    DetailForm,
    ApplyReferralForm,
  },
  props: ['record', 'team'],
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      loading: true,
      application: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        reLicenseNumber: '',
        resume: '',
        contactMethodsOptIn: false,
      },
      applicationSuccess: false,
      isFormValid: false,
    };
  },
  methods: {
    updateFormValidity(isValid) {
      this.isFormValid = isValid;
    },
    submitApplication() {
      if (!this.isFormValid) return;

      const self = this;
      let formData = new FormData();

      formData.append('referral_code', self.$route.params.id);
      formData.append('first_name', self.application.firstName);
      formData.append('last_name', self.application.lastName);
      formData.append('phone_number', self.application.phone);
      formData.append('email', self.application.email);
      formData.append('re_license_number', self.application.reLicenseNumber);
      formData.append('opt_in', self.application.contactMethodsOptIn);
      self.application.resume ? formData.append('resume', self.application.resume) : null;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/public/applications', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            self.applicationSuccess = true;
            toast.success('Application submitted', {
              action: { label: 'Dismiss' },
              description:
                'Your application was successfully submitted.  Use the buttons below to view your new contact, or dismiss this alert.',
            });
          } else {
            toast.error('Application submission error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
